import React, { Component } from 'react';
import Modal from 'rc-dialog';
import { observer } from 'mobx-react';
import Button from 'components/Button/Button';
import SelectField from 'components/Form/Fields/Select/SelectField';
import { FormattedMessage, WrappedComponentProps } from 'react-intl';

import './OnlineOrderFilterModal.scss';

interface Option<T> {
  value: T;
  label: string | JSX.Element;
}

@observer
class FilterModal extends Component<
  {
    onClose: () => void;
    onApplyFilter: (filters: { place: string; status: string }) => void;
    filters: { place: string; status: string };
  } & WrappedComponentProps
> {
  state = {
    selectedPlace: this.props.filters.place || '',
    selectedStatus: this.props.filters.status || '',
  };

  handlePlaceChange = (value: string | null | undefined) => {
    this.setState({ selectedPlace: value || '' });
  };

  handleStatusChange = (value: string | null | undefined) => {
    this.setState({ selectedStatus: value || '' });
  };

  applyFilter = () => {
    const { selectedPlace, selectedStatus } = this.state;
    this.props.onApplyFilter({ place: selectedPlace, status: selectedStatus });
    this.props.onClose();
  };

  render() {
    const { intl } = this.props;
    const placeOptions: Array<Option<string>> = [
      {
        value: ' ',
        label: intl.formatMessage({ id: 'title.order.places.all' }),
      },
      { value: 'TAKE_AWAY', label: intl.formatMessage({ id: 'PICKUP' }) },
      {
        value: 'IN_PLACE',
        label: intl.formatMessage({
          id: 'modal.online.orders.filter.label.inplace',
        }),
      },
    ];
    
    const statusOptions: Array<Option<string>> = [
      {
        value: ' ',
        label: intl.formatMessage({
          id: 'modal.online.orders.filter.status.all',
        }),
      },
      {
        value: 'delivered',
        label: intl.formatMessage({ id: 'title.order.control.status' }),
      },
      {
        value: 'pending',
        label: intl.formatMessage({
          id: 'modal.online.orders.filter.status.pending',
        }),
      },
    ];

    const isApplyButtonDisabled =
      !this.state.selectedPlace && !this.state.selectedStatus;

    return (
      <Modal
        className={'filterModal'}
        onClose={this.props.onClose}
        destroyOnClose
        animation="zoom"
        maskAnimation="fade"
        visible
      >
        <div className={'filterModal__title'}>
          <FormattedMessage id={'modal.online.orders.filter.title'} />
        </div>
        <div className={'filterModal__field'}>
          <label>
            <FormattedMessage id="modal.online.orders.filter.label.location" />
          </label>
          <SelectField
            value={this.state.selectedPlace}
            onChange={this.handlePlaceChange}
            options={placeOptions}
          />
        </div>

        <div className={'filterModal__field'}>
          <label>
            <FormattedMessage id="modal.online.orders.filter.label.status" />
          </label>
          <SelectField
            value={this.state.selectedStatus}
            onChange={this.handleStatusChange}
            options={statusOptions}
          />
        </div>

        <div className={'filterModal__actions'}>
          <Button
            className={'filterModal__button'}
            styleType="ghost"
            onClick={this.props.onClose}
          >
            <FormattedMessage id="button.cancel" />
          </Button>

          <Button
            className={'filterModal__button'}
            type="submit"
            onClick={this.applyFilter}
            disabled={isApplyButtonDisabled}
          >
            <FormattedMessage id="button.filter" />
          </Button>
        </div>
      </Modal>
    );
  }
}

export default FilterModal;
